import React from 'react'
import { Link } from 'gatsby'
import Img from '@/lib/Img'
import NoImg from '@/lib/NoImg'
import { MdChevronRight } from 'react-icons/md'

const ArticlePreview = ({ post, index }) => {
	const url = '/blog/' + post.metaInfo?.slug?.current

	return (
		<article className="anim-fadein border-2 border-grounding-navy/20 rounded-xl overflow-hidden" style={{ '--i': index }}>
			<Link className="group block" to={url}>
				<figure className="aspect-[1.5]">
					{post.featuredImage
						? <Img className="h-full" image={post.featuredImage} alt={post.title} />
						: <NoImg className="w-full h-full object-cover" />
					}
				</figure>

				<div className="py-4 px-3 richtext-sm rounded-b-xl">
					<h2 className="h4 line-clamp" style={{ '--lines': 2 }}>{post.title}</h2>
					{/* <p className="line-clamp" style={{ '--lines': 4 }}>
						{post.excerpt || post.metaInfo?.description}
					</p> */}
					<p className="flex items-center gap-[0.5ch] font-bold link group-hover:decoration-2 text-orange">
						Learn more <MdChevronRight />
					</p>
				</div>
			</Link>
		</article>
	)
}

export default ArticlePreview
